import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'px-6 py-3 rounded-lg font-medium transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed';
  const variantStyles = {
    primary: 'bg-au-green text-white hover:bg-au-green-dark',
    secondary: 'bg-white text-au-green border-2 border-au-green hover:bg-au-green-light'
  };
  return <button className={`${baseStyles} ${variantStyles[variant]} ${className}`} {...props} data-id="element-370">
      {children}
    </button>;
}